'use client';

import { cn } from 'common/utils';
import QuickStats from 'components/v2/modules/portfolio/quick-stats';
import { PortfolioInfoType } from 'service/trading-demo';

interface RightSidebarProps {
  className?: string;
  portfolioData?: PortfolioInfoType;
}

const RightSidebar = ({ className, portfolioData }: RightSidebarProps) => {
  if (!portfolioData) return null;
  return (
    <aside
      className={cn(
        'scrollbar-hide sticky top-16 z-50 ml-auto hidden h-[calc(100vh-64px)] w-[260px] overflow-y-auto pb-3 pt-[15px] grid-in-rightSidebar xl:block',
        className,
      )}
    >
      <div className="space-y-6 px-3 pt-2">
        {/* Quick Stats Widget */}
        <QuickStats portfolioData={portfolioData} />
        {/* Market Trends Widget */}
        {/* <div className="rounded-2xl bg-white p-4 shadow-sm">
          <h3 className="mb-4 text-sm font-semibold text-pp-text-primary">
            マーケットトレンド
          </h3>
          <div className="space-y-3">
            {marketTrends.map((trend, index) => (
              <div
                key={`${trend.symbol}-${index}`}
                className="flex items-center justify-between"
              >
                <div>
                  <div className="text-sm font-semibold text-pp-text-primary">
                    {trend.symbol}
                  </div>
                  <div className="text-xs text-pp-text-secondary">
                    {trend.signal}
                  </div>
                </div>
                <div
                  className={cn(
                    'text-sm font-semibold',
                    trend.isPositive ? 'text-pp-green-primary' : 'text-red-500',
                  )}
                >
                  {trend.change}
                </div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </aside>
  );
};

export default RightSidebar;
